<template>
  <div class="mb-2 position-relative">
    <div class="form-control view-selected">
      <span class="col-gap-1 align-items-baseline d-flex">
        <i
          class="fas fa-envelope fa-lg position-relative"
          style="top:3px"
          v-if="email"
        ></i>
        <i
          v-else
          class="fas fa-phone fa-lg position-relative"
          style="top:3px"
        ></i>
        <p>{{ email ? selectedEmails : selectedPhones }}</p>
      </span>
    </div>
    <div
      class="emails py-2"
      :style="'overflow-y:auto'"
      v-show="checked"
      @click="showOptions"
    >
      <div v-if="email">
        <div
          class="check-devices d-flex mb-2 pl-2 align-items-center"
          v-for="(user, i) in users"
          :key="i"
        >
          <input
            type="checkbox"
            @click="updateVal(user.email)"
            :checked="checkBox(user.email)"
            :id="user.email"
            style="cursor:pointer"
          />
          <label
            for="checkbox d-flex"
            class=" gray4 mb-0 font-16"
            style="margin-left: 0.7rem;font-weight: 100;"
            >{{ user.email }}</label
          >
        </div>
      </div>
      <div v-else>
        <div
          class="check-devices d-flex pl-2 align-items-center"
          v-for="(user, i) in users"
          :key="i"
        >
          <input
            type="checkbox"
            @click="updatePhone(user.phone)"
            :checked="checkBox(user.phone)"
            :id="user._id"
            style="cursor:pointer"
          />
          <label
            for="checkbox d-flex"
            class=" gray4 mb-0"
            style="margin-left: 0.7rem;font-weight: 100;"
            >{{ user.phone }} - {{ user.fullname }}</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    checked: Boolean,
    users: Array,
    selectedEmailList: Array,
    email: Boolean,
  },
  data() {
    return {
      openDropdown: false,
      name: '',
      userList: [],
      mobileList: [],
    };
  },
  methods: {
    showOptions() {
      this.email && this.$emit('open');
      !this.email && this.$emit('open2');
    },
    selectedOptions() {
      this.email && this.$emit('selected', this.userList);
      !this.email && this.$emit('phoneSelect', this.mobileList);
    },

    updateVal(e) {
      if (this.email) {
        if ([...this.userList].includes(e)) {
          const index = this.userList.indexOf(e);
          if (index > -1) {
            this.userList.splice(index, 1);
          }
        } else this.userList = [...this.userList, e];
        this.selectedOptions(this.userList);
      }
    },
    updatePhone(phone) {
      if (!this.email) {
        if ([...this.mobileList].includes(phone)) {
          const index = this.mobileList.indexOf(phone);
          if (index > -1) {
            this.mobileList.splice(index, 1);
          }
        } else this.mobileList = [...this.mobileList, phone];
        this.selectedOptions(this.mobileList);
      }
    },
    checkBox(emails) {
      if (this.selectedEmailList.includes(emails)) {
        return true;
      } else return false;
    }
  },
  mounted() {
    if (this.email) {
      this.userList = [...this.selectedEmailList];
    }
    if (!this.email) {
      this.mobileList = [...this.selectedEmailList];
    }
  },
  computed: {
    selectedEmails() {
      let email = this.$t('select_emails');
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList.length > 0 && this.userList.length <= 1) {
          email = `${this.userList[0]}`;
        } else if (this.userList.length <= 2) {
          email = `${this.userList[0]}, ${this.userList[1]}`;
        } else if (this.userList.length >= 3) {
          email = `${this.userList[0]}, ${this.userList[1]}, ${this.userList[2]}`;
        }
      }
      return email;
    },

    selectedPhones() {
      let phone = this.$t('select_users');
      for (let i = 0; i < this.mobileList.length; i++) {
        if (this.mobileList.length === 1) {
          phone = `${this.mobileList[0]}`;
        } else if (this.mobileList.length === 2) {
          phone = `${this.mobileList[0]}, ${this.mobileList[1]}`;
        } else if (this.mobileList.length >= 3) {
          phone = `${this.mobileList[0]}, ${this.mobileList[1]}, ${this.mobileList[2]}`;
        }
      }
      return phone;
    },
  },
};
</script>

<style src="../assets/css/style.css"></style>

<style scoped>
.form-control {
  border-radius: 0;
}
.emails {
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 100;
  background: white;
  border: solid 1px lightgrey;
  max-height: 6rem;
}
input {
  background: white !important;
}
.view-selected {
  cursor: pointer;
}
.view-selected p {
  white-space: nowrap;
  overflow: hidden;
}
</style>
